<template>
  <div id="app">
    <component :is="currentView" @formChangeView="formSend"></component>
    <!-- <FormView /> -->
  </div>
</template>

<script>
import FormView from './components/FormView.vue';
import FormEnd from './components/FormEnd.vue';

export default {
  name: 'App',
  components: {
    'FormView': FormView,
    'FormEnd' : FormEnd
  },
  data: function() {
    return {
      currentView: FormView
    }
  },
  methods: {
    formSend() {
      this.currentView = FormEnd
    }
  }
}
</script>